import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	root: {
		padding: "32px 0px 0px 100px",
		[theme.breakpoints.down("lg")]: {
			justifyContent: "center",
			padding: "0px",
			paddingTop: "32px",
			paddingLeft: "32px",
			margin: "auto",
		},
	},
	loginBox: {
		width: "360px",
	},
	loginPaper: {
		padding: "12px",
	},
	svgIconSec: {
		paddingLeft: "144px",
		paddingTop: "62px",
		[theme.breakpoints.down("lg")]: {
			display: "none",
		},
	},
	widthRoot: {
		width: "420px",
	},
	loginErrorMessage: {
		paddingLeft: "16px",
	},
	profileRoot: {
		height: "100%",
	},
	paper: {
		width: "400px",
		paddingLeft: "32px",
		paddingTop: "32px",
		height: "100%",
		backgroundColor: theme.palette.common.white,
	},
	email: {
		marginTop: "4px",
		fontWeight: "600",
	},
	mobileNumber: {
		marginTop: "8px",
		fontWeight: "600",
	},
	nameIcon: {
		display: "flex",
		background: theme.palette.primary.main,
		borderRadius: "55px",
		height: "72px",
		width: "72px",
		textAlign: "center",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: "24px",
	},
	nameIconText: {
		color: theme.palette.common.white,
		fontSize: "22px",
		fontWeight: "600",
	},
});
export default styles;
